module.exports = __webpack_public_path__ + "static/media/flexibill-color.97a35726.svg";